import { updateUserDetails } from '@store/slices/authSlice';
import axios from 'axios';
import { endpoints } from '@api/apis';
import { store } from '@store/newstore';

const promiseFetchUserInfo = async () => {
    try {
      const res = await axios.post(endpoints.userInfo, {
        onboardingPartnerCode: '',
      });
      store.dispatch(updateUserDetails(res.data));
      return res.data;
    } catch (err) {
      console.log('err', err);
      throw err;
    }
  };
  


export default promiseFetchUserInfo;
